import Swiper, { Scrollbar, Lazy } from 'swiper';

Swiper.use([Scrollbar, Lazy]);

const selectors = {
  slider: '.js-gallery-swiper',
  scrollbar: '.js-gallery-swiper-scrollbar',
  counter: '.js-gallery-swiper-counter',
  btn: '.js-gallery-swiper-btn',
};

const gallerySlider = () => {
  const elem = document.querySelector(selectors.slider);
  if (!elem) return;

  const swiper = new Swiper(elem, {
    slidesPerView: 'auto',
    // slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      769: {
        spaceBetween: 60,
        // slidesPerView: 1.3,
      },
    },

    // lazy
    lazy: {
      loadPrevNext: true,
    },
    watchSlidesProgress: true,
    loadOnTransitionStart: true,
    watchSlidesVisibility: true,
    grabCursor: true,
    preloadImages: false,

    scrollbar: {
      el: selectors.scrollbar,
      draggable: true,
    },
  });

  const counter = document.querySelector(selectors.counter);
  if (counter) {
    swiper.on('slideChange', (e) => {
      const index = e.activeIndex + 1;

      counter.textContent = index < 10 ? '0' + index : index;
    });
  }

  const btns = document.querySelectorAll(selectors.btn);
  if (btns.length) {
    btns.forEach((btn) => {
      btn.addEventListener('click', () => swiper.slideTo(btn.dataset.index));
    });
  }

  return swiper;
};

export default gallerySlider;
